import FileIcon, { defaultStyles } from "@qwilapp/react-file-icon";
import { GrDocument, GrDocumentCsv, GrDocumentExcel, 
  GrDocumentImage, 
  GrDocumentPdf, GrDocumentPpt, GrDocumentRtf, GrDocumentSound, 
  GrDocumentTxt, GrDocumentWord, GrDocumentZip, 
  GrLink} from "react-icons/gr";

class FIconX {

  static Get(type, size, style = {}, colorTransition = true, useReactFileIcon = false){

    if(colorTransition){
      style.transition = "color 500ms";
    }else{
      if(style?.color?.day && style?.color?.night){
        style.transition = "color 500ms";
      }
    }

    if(type?.includes("image")){
      return <GrDocumentImage size={size} style={style}/>;
    }
    
    if(type?.includes("audio")){
      return <GrDocumentSound size={size} style={style}/>;
    }

    switch(type){
      case "application/pdf": 
        return useReactFileIcon ? 
        <FileIcon extension="pdf" size={size} {...defaultStyles.pdf}/>
         : <GrDocumentPdf size={size} style={style}/>; 
      case "application/vnd.ms-excel":
      case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        return useReactFileIcon ?
        <FileIcon extension="xlsx" size={size} {...defaultStyles.xlsx}/>
        : <GrDocumentExcel size={size} style={style}/>;
      case "text/csv": 
        return useReactFileIcon ?
        <FileIcon extension="csv" size={size} {...defaultStyles.csv}/>
        : <GrDocumentCsv size={size} style={style}/>;
      case "application/rtf":
        return useReactFileIcon ?
        <FileIcon extension="rtf" size={size} {...defaultStyles.rtf}/>
        : <GrDocumentRtf size={size} style={style}/>;
      case "application/msword":
      case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        return useReactFileIcon ?
        <FileIcon extension="docx" size={size} {...defaultStyles.docx}/>
        : <GrDocumentWord size={size} style={style}/>;
      case "text/plain":
        return useReactFileIcon ?
        <FileIcon extension="txt" size={size} {...defaultStyles.txt}/>
        : <GrDocumentTxt size={size} style={style}/>;
      case "application/vnd.ms-powerpoint":
      case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
        return useReactFileIcon ?
        <FileIcon extension="pptx" size={size} {...defaultStyles.pptx}/>
        : <GrDocumentPpt size={size} style={style}/>;
      case "application/zip":
        return useReactFileIcon ?
        <FileIcon extension="zip" size={size} {...defaultStyles.zip}/>
        : <GrDocumentZip size={size} style={style}/>;
      case "link":
        return <GrLink size={size} style={style}/>;
      default:
        return <GrDocument size={size} style={style}/>;
    }
  }

}

export default FIconX;